module.exports = __webpack_public_path__ + "img/downAppCode2.a69fbd15.png";